import { SET_ERROR } from "../App/constants";
import { Agreement } from "./Agreement";
import {
  ACTION_AGREEMENT_DELETE_FAILED,
  ACTION_AGREEMENT_DELETE_SUCCESS,
  ACTION_AGREEMENTS_SAVED,
  ACTION_CREATE_AGREEMENT,
  ACTION_CREATE_AGREEMENT_DIALOG_HIDE,
  ACTION_CREATE_AGREEMENT_DIALOG_SHOW,
  ACTION_CREATE_AGREEMENT_FAILED,
  ACTION_CREATE_AGREEMENT_SUCCESS,
  ACTION_DELETE_AGREEMENT,
  ACTION_DOWNLOAD_AGREEMENTS,
  ACTION_DOWNLOAD_AGREEMENTS_STARTED,
  ACTION_LOAD_AGREEMENTS,
  ACTION_LOAD_AGREEMENTS_COMPLETE,
  ACTION_SAVE_AGREEMENTS,
  ACTION_UPLOAD_AGREEMENTS,
  ACTION_UPLOAD_AGREEMENTS_COMPLETE,
  ACTION_UPLOAD_AGREEMENTS_FAILED,
  ACTION_UPLOAD_AGREEMENTS_SUCCEEDED,
} from "./constants";
import AgreementsPageState, { AgreementsPageStateInitial } from "./state";

export const importExportAgreementsInitialState: AgreementsPageStateInitial = {
  type: "initial",
};

const tableInitialState: AgreementsPageState = {
  loading: false,
  loaded: false,
  agreements: Array<Agreement>(),
  createDialog: {
    visible: false,
    creating: false,
  },
  deleting: {
    agreement: undefined,
  },
  importExportAgreementsState: importExportAgreementsInitialState,
};

const agreementTableReducer = (
  state: AgreementsPageState = tableInitialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): AgreementsPageState => {
  switch (action.type) {
    case ACTION_LOAD_AGREEMENTS:
      return {
        ...state,
        loading: true,
      };
    case ACTION_LOAD_AGREEMENTS_COMPLETE:
      return {
        ...state,
        loading: false,
        loaded: true,
        agreements: action.agreements.sort(Agreement.defaultSort),
      };
    case ACTION_CREATE_AGREEMENT_DIALOG_SHOW:
      return {
        ...state,
        createDialog: { ...state.createDialog, visible: true },
      };
    case ACTION_CREATE_AGREEMENT_DIALOG_HIDE:
      return {
        ...state,
        createDialog: {
          ...state.createDialog,
          visible: false,
          creating: false,
        },
      };
    case ACTION_CREATE_AGREEMENT:
      return {
        ...state,
        createDialog: { ...state.createDialog, creating: true },
      };
    case ACTION_CREATE_AGREEMENT_SUCCESS:
      return {
        ...state,
        agreements: [...state.agreements, action.payload].sort(
          Agreement.defaultSort
        ),
        createDialog: {
          ...state.createDialog,
          creating: false,
          visible: false,
        },
      };
    case ACTION_CREATE_AGREEMENT_FAILED:
      return {
        ...state,
        createDialog: { ...state.createDialog, creating: false },
      };
    case ACTION_DELETE_AGREEMENT:
      return {
        ...state,
        deleting: {
          agreement: action.payload,
        },
      };
    case ACTION_AGREEMENT_DELETE_FAILED:
      return {
        ...state,
        deleting: {
          agreement: undefined,
        },
      };
    case ACTION_AGREEMENT_DELETE_SUCCESS:
      return {
        ...state,
        agreements: state.agreements.filter(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (agreement) => !agreement.equals(state.deleting.agreement!)
        ),
        deleting: {
          agreement: undefined,
        },
      };
    case ACTION_UPLOAD_AGREEMENTS:
      return {
        ...state,
        importExportAgreementsState: {
          type: "uploading",
        },
      };
    case ACTION_UPLOAD_AGREEMENTS_SUCCEEDED:
      return {
        ...state,
        importExportAgreementsState: {
          type: "upload-succeeded",
          agreements: action.agreements,
          agreementImportId: action.agreementImportId,
        },
      };
    case ACTION_UPLOAD_AGREEMENTS_FAILED:
      return {
        ...state,
        importExportAgreementsState: {
          type: "upload-failed",
          errors: action.errors,
        },
      };
    case ACTION_UPLOAD_AGREEMENTS_COMPLETE:
      return {
        ...state,
        importExportAgreementsState: {
          type: "initial",
        },
      };
    case ACTION_SAVE_AGREEMENTS:
      return {
        ...state,
        importExportAgreementsState: {
          type: "saving",
          totalCount:
            state.importExportAgreementsState.type == "upload-succeeded"
              ? state.importExportAgreementsState.agreements.length
              : 0,
        },
      };
    case ACTION_AGREEMENTS_SAVED:
      return {
        ...state,
        importExportAgreementsState: {
          type: "saved",
          totalCount:
            state.importExportAgreementsState.type == "saving"
              ? state.importExportAgreementsState.totalCount
              : 0,
        },
      };
    case ACTION_DOWNLOAD_AGREEMENTS:
      return {
        ...state,
        importExportAgreementsState: {
          type: "downloading",
        },
      };
    case ACTION_DOWNLOAD_AGREEMENTS_STARTED:
      return {
        ...state,
        importExportAgreementsState: {
          type: "initial",
        },
      };
    case SET_ERROR: {
      return {
        ...tableInitialState,
        loaded: state.loaded,
        agreements: state.agreements,
      };
    }
    default:
      return state;
  }
};

export default agreementTableReducer;
